"use client"; // This makes only this component a Client Component

import React from "react";
import { FaReply } from "react-icons/fa";
const EmailButton = ({ recipientEmail, recipientSubject }) => {
  const handleEmailClick = () => {
    if (recipientEmail == 0) {
      alert("No Email Address Found");
    } else {
      const subject = `Reply From Nalanda Vidhya Mandir. "${recipientSubject}"`;
      const body = "";
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipientEmail}&su=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
      window.open(gmailUrl, "_blank");
    }
  };

  return (
    <button
      onClick={handleEmailClick}
      className="mt-3 p-2 mb-2 shadow-4xl hover:border hover:border-gray-400 rounded-md text-gray-800 hover:text-blue-600"
    >
      {/* <MdOutlineEmail className="text-2xl" /> */}
      <FaReply title="Reply" className="text-2xl" />
    </button>
  );
};

export default EmailButton;
